import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import * as fromIntegration from './reducer'
import { EffectsModule } from '@ngrx/effects'
import { IntegrationEffects } from './effects'
import { STORE_ID } from './state'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(STORE_ID, fromIntegration.integrationReducer),
    EffectsModule.forFeature([IntegrationEffects]),
  ],
  declarations: [],
})
export class IntegrationModule {}
